import {$html, APP_NAME} from '../utils/environment';
import AbstractModule from './AbstractModule';
import mustache from 'mustache';

const MODULE_NAME     = 'Map';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.places    = {};
        this.districts = {};
        this.sectors   = {};
        this.opts      = options;
        this.template  = false;

        this.API_KEY = this.opts.api;
    }

    init() {
        this.$el.on(EVENT.CLICK, '.js-map-card-close', (event) => this.closeCard());
        // this.$el.on(EVENT.CLICK, '.js-map-marker', (event) => this.openCard(event));
        this.$el.on(EVENT.CLICK, '.js-map-filters-toggle', (event) => this.toggleFilters());

        this.$el.on(EVENT.CLICK, '.js-accordion-header', (event) => this.toggleAccordion(event));
        this.$el.on(EVENT.CLICK, '.js-map-dropdown-item', (event) => this.toggleDropdownItem(event));

        this.initMap();
    }

    initMap() {
        // Async loading
        if (typeof google === 'undefined') {
            // If google is undefined,
            window._tmp_google_onload = () => {
                this.initMap();
            };

            $.getScript(
                `https://maps.googleapis.com/maps/api/js?sensor=true&v=3.36&language=fr&callback=_tmp_google_onload&key=${this.API_KEY}`,
                function () {
                }
            );
            return false;
        }

        if (typeof BB.gmap === 'undefined') {
            // Error.
            throw new Error('BB.gmap seems to be undefined. Map cannot be instanciated.');
            return false;
        }

        fetch('/template?template=mirabel/template/partial/map-card').then(response => response.json()).then(data => {

            if (!data.success) {
                throw new Error("An error occured when retrieving template");
            }
            this.template = data.template;
        }).catch(errors => console.error(errors));

        const that = this;
        fetch('/api/map/options').then(response => response.json()).then(data => {

            if (!data.success) {
                throw new Error("An error occured when retrieving map options");
            }

            // Display
            data.options.onfocus = (place, map) => {
                var html = mustache.to_html(this.template, place.data('data'));
                $('.js-map_card').html(html);
                this.openCard(event);
            }

            const mapInstance = new BB.gmap.controller(that.$el.find('.js-map_object').get(0), data.options);

            mapInstance.init().ready(function () {
                // mapInstance.fit_bounds();
            });

            that.setMapInstance(mapInstance);
            that.fetchLocations(this.opts.category, this.opts.type);
        }).catch(errors => console.error(errors));

    }

    /**
     * Fetch map location by category
     * @param  {mixed} category  Either a ID or undefined.
     * @return {thisArg}         Chainable.
     */
    fetchLocations(category, type, event = null) {
        this.mapInstance().reset();
        if (typeof this.places[category] !== 'undefined') {
            this.setMapData(category, type, event);
            return this;
        }

        fetch(`/api/map/location?category=${category}&type=${type}`).then(response => response.json()).then(data => {
            this.places[category] = data.places;
            this.setMapData(category, type, event);
            // this.loaded();
        }).catch(errors => console.error(errors));

        return this;
    }

    setMapData(category, type, event = null) {

        let data = this.places[category];

        this.mapInstance().add_places(Object.assign({}, data));

        this.fitBounds();


        if (event && (type === 'sector' || type === 'district') && this.places[category].length === 1) {
            var html = mustache.to_html(this.template, this.places[category][0].data);
            $('.js-map_card').html(html);
            this.openCard(event);
        }
    }

    fitBounds() {
        let padding = {};

        if (window.innerWidth >= 1000) {
            padding = {
                left:   $('.js-header').width(),
                right:  $('.js-map_nav').width(),
                top:    40,
                bottom: 20
            };
        }
        var bounds = new google.maps.LatLngBounds();

        var k = 0;
        this.mapInstance()._loop_all(function(obj) {
            var paths = obj.get_position();
            if (!paths) {
                return false;
            }
            var path;

            if (obj.object().map == null) {
                return false;
            }

            // Worst fix ever.
            if (paths instanceof google.maps.LatLng) {
                bounds.extend(paths);
            } else {
                for (var i = 0; i < paths.getLength(); i++) {
                    path = paths.getAt(i);
                    for (var ii = 0; ii < path.getLength(); ii++) {
                        bounds.extend(path.getAt(ii));
                    }
                }
            }
            k++;

        });

        if (k > 0) {
            this.mapInstance().map().fitBounds(bounds, padding);
            if (this.mapInstance().data('max_fitbounds_zoom')) {
                var max = this.mapInstance().data('max_fitbounds_zoom');
                var current_zoom = this.mapInstance().map().getZoom();
                if (current_zoom > max) {
                    this.mapInstance().map().setZoom(max);
                }
            }
        }


    }

    setMapInstance(instance) {
        this.map = instance;
        return this;
    }

    mapInstance() {
        return this.map;
    }

    openCard(event) {
        setTimeout(() => {
            $html.addClass("has-map-card-open");
        }, 150)
    }

    closeCard() {
        $html.removeClass("has-map-card-open");
        this.$el.find('.js-map-marker.is-active').removeClass('is-active');
    }

    toggleFilters() {
        $html.toggleClass('has-map-filters-open');
    }

    toggleAccordion(event) {
        if (!$(event.currentTarget).parent().hasClass('is-open')) return false;

        this.closeCard();

        const category = $(event.currentTarget).attr('data-id');
        const type     = $(event.currentTarget).attr('data-type');
        this.fetchLocations(category, type);
    }

    toggleDropdownItem(event) {

        $html.removeClass('has-map-filters-open');

        $('.js-map-dropdown-item', this.$el).filter('.is-active').removeClass('is-active');
        $(event.currentTarget).addClass('is-active');

        const category       = $(event.currentTarget).find('a').attr('data-id');
        const parentCategory = $(event.currentTarget).parent().closest('li').find('.js-accordion-header').attr('data-type');
        // if (parentCategory === 'district' || parentCategory === 'sector') {
            this.closeCard();
        // }

        this.fetchLocations(category, parentCategory, event);
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
